import { Link } from 'react-router-dom';
import { MapPin, Clock } from 'lucide-react';
import { formatPrice } from '@/lib/helpers';
import { cn } from '@/lib/utils';
import { buildEventPath, isEventLive } from '../utils/eventUtils';
import { LiveBadge } from './LiveBadge';
import { FREE_PILL_COLOR_CLASS } from '../constants/badgeStyles';

export function EventPublicCard({ event, className }) {
  const { id, title, dateLabel, location, isFree, ticketPrice, imageUrl } = event;
  const live = isEventLive(event._raw);

  return (
    <Link
      to={buildEventPath(id, title)}
      className={cn(
        'group flex flex-col w-full bg-card rounded-3xl overflow-hidden',
        'border border-border/60 hover:border-border',
        'hover:shadow-xl transition-all duration-300 hover:-translate-y-1',
        className
      )}
    >
      {/* Image */}
      <div className="relative aspect-video overflow-hidden bg-muted">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />

        {/* Live badge — top left */}
        {live && (
          <div className="absolute top-3 left-3">
            <LiveBadge />
          </div>
        )}

        {/* Price badge — top right */}
        <div className="absolute top-3 right-3">
          <span className={cn(
            'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold',
            'backdrop-blur-sm shadow-sm',
            isFree
              ? FREE_PILL_COLOR_CLASS
              : 'bg-background/90 text-foreground'
          )}>
            {isFree ? 'Gratuito' : formatPrice(ticketPrice)}
          </span>
        </div>
      </div>

      {/* Card body */}
      <div className="flex flex-col flex-1 p-4 gap-2">
        <h3 className="font-semibold text-foreground leading-snug line-clamp-2">
          {title}
        </h3>
        <div className="mt-auto flex flex-col gap-1.5 text-xs text-muted-foreground pt-1">
          <div className="flex items-center gap-1.5">
            <Clock className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{dateLabel}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <MapPin className="w-3.5 h-3.5 flex-shrink-0" />
            <span className="truncate">{location}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}
